import { useState, useEffect } from "react";
import { auth } from "../firebase";
import config from "../config";

function BackendTest() {
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchWithAuth = async () => {
      try {
        // Get the current user's token
        const token = await auth.currentUser?.getIdToken(true);

        // Test the protected endpoint with the token
        const response = await fetch(`${config.apiUrl}/protected`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await response.text();
        setMessage(data);
        setLoading(false);
      } catch (error) {
        setError(error.message);
        setLoading(false);
      }
    };

    fetchWithAuth();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div>
      <h2>Backend Connection Test</h2>
      <p>
        Response from server: <strong>{message}</strong>
      </p>
      <p>User: {auth.currentUser?.email}</p>
    </div>
  );
}

export default BackendTest;
